import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthContextProvider } from "./contexts/AuthContext";
import { HelmetProvider } from "react-helmet-async";
if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      const registration = await navigator.serviceWorker.register(
        "/firebase-messaging-sw.js"
      );
      // console.log("Service Worker registered with scope:", registration.scope);

      // Check if the service worker is already controlling the page
      if (!navigator.serviceWorker.controller) {
        // Force activation by updating the service worker
        await registration.update();
        // console.log("Service Worker updated and activated.");
      }
    } catch (error) {
      console.error("Service Worker registration failed:", error);
    }
  });
}
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <HelmetProvider>
    <AuthContextProvider>
      <App />
    </AuthContextProvider>
  </HelmetProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
